import { httpservice } from '../services';
import { constants } from '../constant/constant';

const doVerifyTwoFAForUser = (otpData) => httpservice()
  .post(constants.API.VERIFY_TWO_FA, otpData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default doVerifyTwoFAForUser;
